import React from 'react'

function CenterComponents() {
    return (
        <div>

            Center Component
        {/* <div id="">
            <main>
                <div class="container-fluid px-4">
                    <h1 class="mt-4">Dashboard</h1>
                    <ol class="breadcrumb mb-4">
                        <li class="breadcrumb-item active">Dashboard</li>
                    </ol>
                   


                </div>
            </main>
        </div> */}

        </div>
    )
}

export default CenterComponents
